import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['icon']
  static values = { dark: Boolean }

  connect() {
    const stored = localStorage.getItem('theme')
    if (stored === 'dark') {
      this.darkValue = true
    } else if (stored === 'light') {
      this.darkValue = false
    } else {
      this.darkValue = window.matchMedia('(prefers-color-scheme: dark)').matches
    }
    this.apply()
  }

  toggle() {
    this.darkValue = !this.darkValue
    this.apply()
    localStorage.setItem('theme', this.darkValue ? 'dark' : 'light')
  }

  apply() {
    if (this.darkValue) {
      document.documentElement.setAttribute('data-theme', 'dark')
    } else {
      document.documentElement.removeAttribute('data-theme')
    }
  }
}
